import { INVALID_PRODUCT_CONTRACT_NOT_EMPTY, INVALID_STRING_DISALLOWED_CHARACTERS } from "@/constants/invalids";
import { PATTERN } from "@/constants/pattern";
import { getDisallowedCharacters, replaceStr } from "@/utils/string";
import { validator } from "@/utils/validator";

export const customerUserFormSchema = validator.object().shape({
  fullName: validator
    .string()
    .trim()
    .emptyToNull()
    .test("is-valid-name", INVALID_STRING_DISALLOWED_CHARACTERS, function (value) {
      if (!value) return true;
      const disallowedCharacters = getDisallowedCharacters(value, PATTERN.NAME_CHARACTER);
      if (disallowedCharacters.length === 0) return true;
      const { path, createError } = this;
      return createError({
        path,
        message: () => replaceStr(INVALID_STRING_DISALLOWED_CHARACTERS, { characters: disallowedCharacters.join("、") }),
      });
    })
    .limit(26)
    .label("ユーザー名")
    .required(),
  email: validator.string().trim().emptyToNull().autoTransformToHalfWidth().email().limit(60).label("メールアドレス").required(),
  newEmail: validator.string().trim().emptyToNull().autoTransformToHalfWidth().email().limit(60).label("新しいメールアドレス").nullable().default(null),
  role: validator.string().isSelection().label("権限").required(),
  status: validator.string().isSelection().label("ステータス").required(),
  // Required only when the org actually holds selectable product contracts — otherwise there is
  // nothing to check and the form would be impossible to submit. The flag comes from the form
  // context (`useForm({ context })`).
  productCodes: validator
    .array()
    .of(validator.string().required())
    .label("プロダクトアクセス権限")
    .default([])
    .when("$hasSelectableProductContracts", {
      is: true,
      then: (schema) => schema.min(1, INVALID_PRODUCT_CONTRACT_NOT_EMPTY),
    }),
});
